import React from 'react';
import ReactDOM from 'react-dom/client';
// Police auto-hébergée (sous-ensemble latin, accents compris) : aucune requête vers
// Google Fonts, donc aucune adresse IP transmise à un tiers.
import '@fontsource/poppins/latin-400.css';
import '@fontsource/poppins/latin-500.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-700.css';
import '@fontsource/poppins/latin-800.css';
import './styles/tokens.css';
import './styles/variables.css';
import './styles/shared.css';
import './index.css';
import App from './App';
import { injectCSSColors } from './constants/colors';

injectCSSColors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
